import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class RolePermissionService {
  static ENDPOINT = `${BASE}/rolePermission`;

  static async replace(data) {
    return await request({
      url: `${this.ENDPOINT}/replace`,
      method: 'PUT',
      headers: {'Accept': 'application/json'},
      body: data
    })
  }
}

export default RolePermissionService;
